import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { PATH_SIGN_UP } from '../common/constants/paths';
import { isBankSetupOnHold } from '../utils/is-verification-in-progress';

// Back from the verification screen can land here; /new-sign-up re-checks status and picks the hold page.
export default defineNuxtRouteMiddleware(() => {
  const { data } = useAuth();
  const $auth = data.value ?? null;

  if ($auth && isBankSetupOnHold($auth)) {
    return navigateTo({ path: PATH_SIGN_UP }, { replace: true });
  }
});
